
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { PVC } from "@consts/ppvc";
import type { IProduct } from "@type/products";
import { getAllPvcByParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next";
import { Breadcrumb } from "../../../components/breadcrumb";
interface IProductPage {
    products: IProduct[];
}
const PvcDoorsPage: NextPage<IProductPage> = ({ products }) => (<>
    <NextSeo languageAlternates={[
        {
            href: "https://knsokna.pl/pvc/sliding-doors",
            hrefLang: "x-default",
        },
        { href: "https://knswindows.com/pvc/sliding-doors", hrefLang: "en" },
        { href: "https://knsokna.pl/pvc/sliding-doors", hrefLang: "pl" },
        { href: "https://knsfenster.de/pvc/sliding-doors", hrefLang: "de" },
        { href: "https://kns-okna.eu/pvc/sliding-doors", hrefLang: "cs" },
        { href: "https://knsfinestre.it/pvc/sliding-doors", hrefLang: "it" },
        { href: "https://knsfenetres.fr/pvc/sliding-doors", hrefLang: "fr" },
        { href: "https://knsokna.eu/pvc/sliding-doors", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
        <Breadcrumb />
        <Products products={products}/>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products } = await getAllPvcByParent(PVC.SLIDING_DOORS[LOCALE as keyof typeof PVC.SLIDING_DOORS], LOCALE);
    return {
        props: {
            products,
        },
    };
};
export default PvcDoorsPage;

    async function __Next_Translate__getStaticProps__1a19cd2bfab__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/sliding-doors/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bfab__ as getStaticProps }
  